"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentationRequestQueryType = void 0;
var PresentationRequestQueryType;
(function (PresentationRequestQueryType) {
    PresentationRequestQueryType["Frame"] = "QueryByFrame";
    PresentationRequestQueryType["Example"] = "QueryByExample";
    PresentationRequestQueryType["SimpleZK"] = "SimpleZKQuery";
})(PresentationRequestQueryType = exports.PresentationRequestQueryType || (exports.PresentationRequestQueryType = {}));
